export default {
  es: {
    diagnosis_diabetes: 'Diagnostico Diabetes',
    diagnosis_hypertensions: 'Diagnostico Hipertensión',
    lastPsychologyValorationDate: 'Fecha de la última valoración psicológica',
    lastRiskPsychosocialDate: 'Fecha último riesgo general y social',
    constructionAccessAssessment: 'Valoración para construcción de acceso',
    'Solicitado y valorado': 'Solicitado y valorado',
    'Solicitado y NO valorado': 'Solicitado y no valorado',
    'No solicitado': 'No solicitado',
    'CON presencia': 'Si',
    'SIN presencia': 'No',
    'No Registra': 'No registra',
    'Sin registro': 'Sin registro',
    lastValuationDate: 'Fecha de última valoración',
    generalSocialRegisterDate:
      'Fecha de registro de riesgo general y social -TS',
    generalSocialTSocialRisk: 'Riesgo general y social - Trabajo social',
    proteinEnergeticWear: 'Desgaste protéico-energético (estadíos 4 y 5)',
    schedulingAlert: 'Alerta de agendamiento',
    patientsWithScheduling: 'Pacientes con agendamiento',
    lastHBSUp10: 'Último HBs >=10',
    dateLastHBSUp10: 'Fecha del último HBs >=10',
    lastHBSUnder10: 'Último HBs <10',
    dateLastHBSUnder10: 'Fecha del último HBs <10',
    vaccinationSchedulingHB: 'Esquema de vacunación Hepatitis B',
    patients: 'pacientes',
    Descendio: 'Descendio',
    'Sin registro o No Descendio': 'Sin registro o No Descendio',
    'Si coincide': 'Si coincide',
    'No coincide': 'No coincide',
    dateLastApplication3rdDose: 'Fecha de la última aplicación 3ra dosis',
    postVaccineAntiHbs: 'Control antiHBs post-vacuna',
    riskRegister: 'Registro de riesgo en consulta de nefrología',
    lossHepatitisImmunity: 'Pérdida de inmunidad hepatitis B',
    lossHepatitisImmunityDescription:
      'Pacientes en estadíos 4 o 5 cuyo último registro de anticuerpos descendió a un valor < 10unid/L',
    correlationRiskRateProgression:
      'Correlación nivel de riesgo y velocidad de progresión',
    patientsScheduleVaccination:
      'Pacientes con esquema de vacunación para Hepatitis B: 0-1-6 Meses',
    doseDate1: 'Fecha dosis 1',
    doseDate2: 'Fecha dosis 2',
    dose: 'Dosis',
    cuantos_dosis2: '2da dosis',
    cuantos_dosis3: '3ra dosis',
    cuantos_vencidos: 'Vencido',
    seroStatusHepatitisB: 'Seroestado hepatitis B (estadíos 4 y 5)',
    Inmune: 'Inmune',
    Susceptible: 'Susceptible',
    'Susceptible no respondedor': 'Susceptible no respondedor',
    Infectado: 'Infectado',
    dontRegister: 'No registra',
    register: 'Si registra',
    'Menos de 10': 'Menos de 10',
    'Mas de 10': 'Más de 10',
    Normal: 'Normal',
    Bajo: 'Bajo',
    Medio: 'Medio',
    Alto: 'Alto',
    SinRegistro: 'Sin Registro',
    progressionVelocity: 'Velocidad de la progresión',
    lowProgresor: 'Riesgo bajo',
    mediumProgresor: 'Riesgo medio',
    highProgresor: 'Riesgo alto',
    Critico: 'Crítico',
    serostateClasification: 'Clasificación de seroestado',
    serostateClasificationHB: 'Clasificación seroestado Hepatitis B',
    vaccinationSchedule: 'Esquema de vacunación',
    vaccinationScheduling: 'Agendamiento de vacunación',
    dateLastAntiHBs: 'Fecha último antiHBs',
    resultLastAntiHBs: 'Resultado último antiHBs',
    treatmentOptions: 'Opciones de tratamiento',
    recommendedByScheduling: 'Pacientes recomendados por agendar',
    albuminuriaProgress: 'Evolución de albuminuria',
    TFGDeterioration: 'Deterioro de más del 25% de TFG',
    hemoglobin: 'Hemoglobina',
    phosphorus: 'Fósforo',
    potassium: 'Potassium',
    nutritionalIndicator: 'Indicador nutricional',
    Delgadez: 'Delgadez',
    Preobeso: 'Sobrepeso',
    Obesidad: 'Obesidad',
    antiBodyAntiHBs: 'Anticuerpos antiHBs (estadíos 4 y 5)',
    ambulatoryMonitoring: 'Alerta de monitoreo ambulatorio',
    numberOfPatients: 'No. de pacientes',
    percentageOfPatients: 'Porcentaje de pacientes',
    risk: 'Riesgo',
    month: 'Mes',
    names: 'Nombres',
    lastNames: 'Apellidos',
    id: 'Número de documento',
    age: 'Edad',
    insuranceCarrier: 'Aseguradora',
    stageTFGCGNoAdjustment: 'Estadío por TFG Cockroft Gault sin ajuste',
    TFGCGSNoAdjustment: 'TFG Cockroft Gault sin ajuste',
    TFGCGSNoAdjustmentDate: 'Fecha TFG Cockroft Gault sin ajuste',
    kidneyUnit: 'Unidad Renal',
    TFGCEpi2009: 'TFG CKD EPI 2009',
    TFGCEpi2009Date: 'Fecha TFG CKD EPI 2009',
    stageTFGCEpi2009: 'Estadío TFG CKD EPI 2009',
    modality: 'Modalidad',
    therapy: 'Terapia',
    lastHemoglobin: 'Última HbA1c%',
    lastHemoglobinDate: 'Fecha última HbA1c%',
    filterBy: 'Filtrar por',
    documentType: 'Tipo de documento de identidad',
    albuminuria: 'Clasificación de albuminuria',
    patientsNumber: 'No. de pacientes',
    proteinuriaLastDate: 'Fecha última proteinuria 24h',
    proteinuriaLastScore: 'Resultado última proteinuria 24h',
    proteinuriaPenultimateDate: 'Fecha penúltima proteinuria 24h',
    proteinuriaPenultimateScore: 'Resultado penúltima proteinuria 24h',
    diabetesDiagnostic: 'Diagnóstico diabetes (Si/No)',
    alert: 'Alerta',
    hipertensionDiagnostic: 'Diagnóstico hipertensión arterial(Si/No)',
    glomerularDiagnostic: 'Diagnóstico enfermedad glomerular (Si/No)',
    Yes: 'Si',
    No: 'No',
    Mejora: 'Mejora',
    Empeora: 'Empeora',
    Estable: 'Estable',
    noComparission: 'Sin Datos',
    variation: 'Variación',
    dateLastAlbuminuriaRAC: 'Fecha última albuminuria 24h o RAC',
    resultsLastAlbuminuriaRAC: 'Resultado última albuminuria 24h o RAC',
    datePenultimateAlbuminuriaRAC: 'Fecha penúltima albuminuria 24h o RAC',
    resultsPenultimateAlbuminuriaRAC:
      'Resultado penúltima albuminuria 24h o RAC',
    diabetesDiagnosis: 'Diagnóstico diabetes (Si/No)',
    hypertensionDiagnosis: 'Diagnóstico hipertensión (Si/No)',
    glomerularDiagnosis: 'Diagnóstico enfermedad glomerular (Si/No)',
    metabolicDiabetesTitle: 'Control metabólico de diabetes',
    metabolicDiabetesDesc: 'Hemoglobina glicosilada',
    bloodPressureControl: 'Control de tensión arterial',
    Baja: 'Baja',
    Alta: 'Alta',
    Aceptable: 'Aceptable',
    'Muy Alta': 'Muy Alta',
    BajaSub: '<90 o <60',
    AltaSub: '≥140-160 o ≥90-100',
    AceptableSub: '≥90-140 o ≥60-90',
    'Muy AltaSub': '≥160 o ≥100',
    access: 'Accesos',
    accessDesc:
      'Pacientes con tasa de filtración glomerular < 17 mL/min/1.73m²',
    P1: 'P1: <500mg / 24h',
    P2: 'P2: [≥500 y <1000mg / 24h]',
    P3: 'P3: [≥1000 y <3500mg / 24h]',
    P4: 'P4: ≥3500mg / 24h',
    'Sin Registros': 'Sin registros',
    psychosocialRiskPsychology: 'Riesgo psicosocial - Psicología',
    psychosocialRisk: 'Registro de riesgo psicosocial - Psicología',
    psychosocialGeneralRisk: 'Registro de riesgo general y social - T. Social',
    Vencidos: 'Vencidos',
    'Proximos a vencer en 3 meses': 'Próximos a vencer en 3 meses',
    'Proximos a vencer en 6 meses': 'Próximos a vencer en 6 meses',
    'No valorados': 'No valorados',
    assesmentPsychology: 'Valoración por psicología',
    nursingEducation: 'Educación (Enfermería)',
    case1: 'Caso 1',
    case2: 'Caso 2',
    case3: 'Caso 3',
    subCase1:
      'Pacientes en estadío 1, 2 y 3 que NO han tenido educación en el último semestre/año.',
    subCase2:
      'Pacientes en estadío 4 y 5 que NO han tenido educación en el último trimestre.',
    subCase3:
      'Pacientes en estadío 4 y 5 que NO han tenido charla de opciones de tratamiento en el último semestre.',
    PatientsDissentTitle: 'Pacientes con disentimiento',
    PatientsWithoutPsychologyAssessment: 'Sin valoración psicológica',
    'Registra intervencion': 'Registra intervención',
    'No registra': 'No registra',
    revisionType: 'Tipo de revisión',
    optionsTreatmentsLastDate:
      'Fecha de último registro de opciones de tratamiento',
    periodicityAttention: 'Periodicidad de atención - Trabajo social',
    patientEvents: 'Eventos de pacientes',
    type: 'Tipo',
    semestral: 'Semestral',
    trimestral: 'Trimestral',
    mensual: 'Mensual',
    FollowUp: 'Seguimiento Ausentismo/Adherencia',
    Search: 'Buscar',
    Reset: 'Limpiar'
  },
  en: {
    diagnosis_diabetes: 'Diagnosis Diabetes',
    diagnosis_hypertensions: 'Diagnosis Hypertension',
    lastPsychologyValorationDate: 'Last psychology valoration date',
    lastRiskPsychosocialDate: 'Last risk psychosocial date',
    constructionAccessAssessment: 'Construction access assessment',
    'Solicitado y valorado': 'Requested and valued',
    'Solicitado y NO valorado': 'Requested and not valued',
    'No solicitado': 'Not valued',
    'CON presencia': 'Yes',
    'SIN presencia': 'No',
    'No Registra': 'No register',
    'Sin registro': 'No register',
    lastValuationDate: 'Last valuation date',
    generalSocialRegisterDate: 'General and social risk register date SW',
    generalSocialTSocialRisk: 'General and social risk - Social work',
    proteinEnergeticWear: 'Protein-energy wear (stages 4 and 5)',
    schedulingAlert: 'Scheduling alert',
    patientsWithScheduling: 'Patients with scheduling',
    lastHBSUp10: 'Último HBs >=10',
    dateLastHBSUp10: 'Fecha del último HBs >=10',
    lastHBSUnder10: 'Último HBs <10',
    dateLastHBSUnder10: 'Fecha del último HBs <10',
    vaccinationSchedulingHB: 'Vaccination scheduling Hepatitis B',
    patients: 'patients',
    Descendio: 'Descended',
    'Sin registro o No Descendio': 'W¡ithout register or not descended',
    'Si coincide': 'Match',
    'No coincide': 'Unmatch',
    dateLastApplication3rdDose: 'Date of the last application 3rd dose',
    postVaccineAntiHbs: 'AntiHBs post-vaccine control',
    riskRegister: 'Risk register in nephrology consultation',
    lossHepatitisImmunity: 'Loss immunity hepatitis B',
    lossHepatitisImmunityDescription:
      'Patients in stages 4 or 5 whom their last antibodies register descended to < 10unit/L',
    correlationRiskRateProgression:
      'Risk level correlation and propagation velocity',
    patientsScheduleVaccination:
      'Patients with schedule vaccination for Hepatitis B: 0-1-6 Months',
    doseDate1: 'Dose date 1',
    doseDate2: 'Dose date 2',
    dose: 'Dose',
    cuantos_dosis2: '2nd dose',
    cuantos_dosis3: '3rd dose',
    cuantos_vencidos: 'Expired',
    seroStatusHepatitisB: 'Serostatus hepatitis B (stages 4 and 5)',
    'Menos de 10': 'Less than 10',
    'Mas de 10': 'More than 10',
    Normal: 'Normal',
    Bajo: 'Low',
    Medio: 'Medium',
    Alto: 'High',
    SinRegistro: 'No Register',
    progressionVelocity: 'Progression velocity',
    lowProgresor: 'Low risk',
    mediumProgresor: 'Medium risk',
    highProgresor: 'High risk',
    Critico: 'Critical',
    serostateClasification: 'Serostate classification',
    serostateClasificationHB: 'Serostate classification Hepatitis B',
    vaccinationSchedule: 'Vaccination schedule',
    vaccinationScheduling: 'Vaccination scheduling',
    dateLastAntiHBs: 'Date of the last antiHBs',
    resultLastAntiHBs: 'Result of the last antiHBs',
    treatmentOptions: 'Treatment options',
    recommendedByScheduling: 'Patient recommended by scheduling',
    albuminuriaProgress: 'Albuminuria progress',
    TFGDeterioration: 'TFG deterioration more than 25%',
    hemoglobin: 'Hemoglobin',
    potassium: 'Potassium',
    phosphorus: 'Phosphorus',
    nutritionalIndicator: 'Nutritional indicator',
    Delgadez: 'Thinness',
    Preobeso: 'Overweight',
    Obesidad: 'Obesity',
    antiBodyAntiHBs: 'Antibodies antiHBs (stages 4 y 5)',
    ambulatoryMonitoring: 'Ambulatory monitoring alert',
    numberOfPatients: 'No. of patients',
    percentageOfPatients: 'Percentage of patients',
    risk: 'Risk',
    month: 'Month',
    names: 'Names',
    lastNames: 'Last names',
    id: 'Document number',
    age: 'Age',
    insuranceCarrier: 'Insurance carrier',
    stageTFGCGNoAdjustment: 'TFG Cockroft Gault Stage no adjustment',
    TFGCGSNoAdjustment: 'TFG Cockroft Gault no adjustment',
    TFGCGSNoAdjustmentDate: 'TFG Cockroft Gault no adjustment date',
    kidneyUnit: 'Kidney unit',
    TFGCEpi2009: 'TFG CKD EPI 2009',
    TFGCEpi2009Date: 'TFG CKD EPI 2009 date',
    stageTFGCEpi2009: 'Stage TFG CKD EPI 2009',
    modality: 'Modality',
    therapy: 'Therapy',
    lastHemoglobin: 'Last HbA1c%',
    lastHemoglobinDate: 'Last HbA1c% date',
    filterBy: 'Filter by',
    documentType: 'Document type',
    albuminuria: 'Albuminuria clasification',
    patientsNumber: 'Patients number',
    proteinuriaLastDate: 'Proteinuria 24h last date',
    proteinuriaLastScore: 'Proteinuria 24h last score',
    proteinuriaPenultimateDate: 'Proteinuria 24h penultimate date',
    proteinuriaPenultimateScore: 'Proteinuria 24h penultimate score',
    diabetesDiagnostic: 'Diabetes Diagnostic (Yes/No)',
    alert: 'Alert',
    hipertensionDiagnostic: 'Hipertension diagnostic (Yes/No)',
    glomerularDiagnostic: 'Glomerular disease diagnostic (Yes/No)',
    Yes: 'Yes',
    No: 'No',
    Mejora: 'Better',
    Empeora: 'Worse',
    Estable: 'Stable',
    variation: 'Variation',
    dateLastAlbuminuriaRAC: 'Last date albuminuria 24h o RAC',
    resultsLastAlbuminuriaRAC: 'Last result albuminuria 24h o RAC',
    datePenultimateAlbuminuriaRAC: 'Penultimate date albuminuria 24h o RAC',
    resultsPenultimateAlbuminuriaRAC:
      'Penultimate result albuminuria 24h o RAC',
    diabetesDiagnosis: 'Diabetes diagnosis (Yes/No)',
    hypertensionDiagnosis: 'Hypertension arterial diagnosis (Yes/No)',
    glomerularDiagnosis: 'Gramerular illness diagnosis (Yes/No)',
    metabolicDiabetesTitle: 'Metabolic control of diabetes',
    metabolicDiabetesDesc: 'Glycosylated hemoglobin',
    bloodPressureControl: 'Blood pressure control',
    Baja: 'Low',
    Alta: 'High',
    Aceptable: 'Aceptable',
    noComparission: 'Without data',
    'Muy Alta': 'Too high',
    BajaSub: '<90 or <60',
    AltaSub: '≥140-160 or ≥90-100',
    AceptableSub: '≥90-140 or ≥60-90',
    'Muy AltaSub': '≥160 or ≥100',
    dontRegister: 'Do not register',
    register: 'Register',
    access: 'Access',
    accessDesc: 'Patients with Glomerular Filtration Rate < 17 mL/min/1.73m²',
    P1: 'P1: <500mg / 24h',
    P2: 'P2: [≥500 y <1000mg / 24h]',
    P3: 'P3: [≥1000 y <3500mg / 24h]',
    P4: 'P4: ≥3500mg / 24h',
    'Sin Registros': 'No records',
    psychosocialRiskPsychology: 'Psychosocial Risk - Psychology',
    psychosocialRisk: 'Psychosocial risk register - Psychology',
    psychosocialGeneralRisk: 'General and social risk register - Social work',
    Vencidos: 'Overdue',
    'Proximos a vencer en 3 meses': 'Next to expire in 3 months',
    'Proximos a vencer en 6 meses': 'Next to expire in 6 months',
    'No valorados': 'Not valued',
    assesmentPsychology: 'Assessment by psychology',
    nursingEducation: 'Education (Nursing)',
    case1: 'Case 1',
    case2: 'Case 2',
    case3: 'Case 3',
    subCase1:
      'Stage 1, 2 and 3 patients who have NOT had an education in the last semester/year.',
    subCase2:
      'Stage 4 and 5 patients who have NOT had an education in the last trimester.',
    subCase3:
      'Stage 4 and 5 patients who have NOT had discussion of treatment options in the last semester.',
    PatientsDissentTitle: 'Patients with dissent',
    PatientsWithoutPsychologyAssessment: 'Without psychology assessment',
    'Registra intervencion': 'Record intervention',
    'No registra': 'Without register',
    revisionType: 'Revision type',
    optionsTreatmentsLastDate: 'Date of last registration of treatment options',
    periodicityAttention: 'Periodicity of care - Social work',
    patientEvents: 'Patient events',
    type: 'Type',
    semestral: 'Biannual',
    trimestral: 'Quarterly',
    mensual: 'Monthly',
    FollowUp: 'Follow up Absenteeism/Adherence',
    Search: 'Search',
    Reset: 'Reset'
  }
};
